<template>
  <app-base-main :no-padding="!padding"
    :table-shadow="tableShow"
    class="product-analysis-copy">
    <template #filter-group>
      <product-analysis-filter :filter="params"
        :query-loading="queryBtnLoading"
        @search="search"
        @reset="reset">
        <template #right>
          <gj-tool-group setting
            table-type="vxe-virtual-tree"
            :download="$permission('skuAnalyze:export')"
            download-url="/operation/skuAnalyze/show/export"
            :download-params="globalParams"
            help
            :table-name="tableName"
            :table-columns="columns"
            :sort-gjtable="$refs.gjTable">
          </gj-tool-group>
        </template>
      </product-analysis-filter>
    </template>
    <template #table>
      <gj-tree-table :list="tableData"
        ref="gjTable"
        :loading="loading"
        :columns="columns"
        class="product-analysis-copy-table"
        :params="params"
        :pagerConfig="pagination"
        :isSeq="false"
        :show-summary="isMeaningful(summaryObject)"
        :summary-object="summaryObject"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:image="{row}">
          <gj-image :src="row.imageUrl"></gj-image>
        </template>
        <template v-slot:skuNameAndSku="{row}">
          <template v-if="row.sku">
            <el-row type="flex">
              <gj-text max-width="90%">{{row.skuName | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.skuName"></gj-copy-icon>
            </el-row>
            <el-row type="flex">
              <gj-text max-width="90%">{{row.sku | defaultShow}}</gj-text>
              <gj-copy-icon :content="row.sku"></gj-copy-icon>
            </el-row>
          </template>
          <template v-else>
            {{row.marketName | defaultShow}}
          </template>
        </template>
        <template v-slot:msku="{row}">
          <template v-if="row.parent">
            <gj-popover-panel
                v-if="row.marketMskuList && row.marketMskuList.length > 1"
                placement="right"
                :width="'250px'"
                :data="row.marketMskuList">
              <gj-text max-width="90%">{{row.msku | defaultShow}}</gj-text>
            </gj-popover-panel>
            <template v-else>{{row.msku | defaultShow}}</template>
          </template>
          <template v-else>{{row.msku | defaultShow}}</template>
        </template>
        <template v-slot:unitsOrdered="{row}">
          <div>{{row.unitsOrdered | defaultShow}}</div>
          <div v-if="showTestOrder">{{row.bogusQuantity | defaultShow}}</div>
        </template>
        <template v-slot:orders="{row}">
          <div>{{row.orders | defaultShow}}</div>
          <div v-if="showTestOrder">{{row.bogusOrders | defaultShow}}</div>
        </template>
        <template v-slot:orderProductSales="{row}">
          <div>{{row.orderProductSales | defaultShow(row.currencySymbol)}}</div>
          <div v-if="showTestOrder">{{row.bogusSalesCost | defaultShow(row.currencySymbol)}}</div>
        </template>
      </gj-tree-table>
    </template>
  </app-base-main>
</template>

<script>
import ProductAnalysisFilter from "./widget/filter.vue";
import {queryMixin, noRepeatQueryMixin} from "@/minxins";
import {getProductPerformedAnalysis} from "@/api/statistics";
import {isMeaningful} from "@/utils/common";
import {analysisMixin} from "@/views/modules/statistics/common/analysis/mixins";
import {DATE_SHORTCUTS} from "@/utils/const";
import {columns} from './data.js'
export default {
  name: "app-product-analysis-performance",
  components: {ProductAnalysisFilter},
  mixins:[queryMixin, analysisMixin, noRepeatQueryMixin],
  data() {
    return {
      isMeaningful,
      tableName: 'productAnalysisPerformance',
      tableData: [],
      columns,
      index: 0,
      params: {
        currency: 'USD',
        categoryIds: null,
        brandIds: null,
        keyword: {
          key: 'sku',
          value: null,
        },
        date: DATE_SHORTCUTS.last14Day.date,
        userPermission: null,
      },
      summaryObject: null,
      showTestOrder:false
    }
  },
  created() {
    this.sort.prop = 'unitsOrdered';
  },
  methods: {
    $gjQuery() {
      this.loading = true;
      this.queryBtnLoading = true;
      let params = {
        model: this.params,
        ...this.queryPagination,
        ...this.querySort
      }
      this.globalParams = params
      getProductPerformedAnalysis(params).then((data) => {
        this.tableData = data.records.map((item,index)=>{
          if(item.expandItems && item.expandItems.length>1){
            item.parent = true;
            item.marketMskuList = [{label: '店铺/国家', value: 'MSKU', bold: true},...(item.expandItems||[]).map(v=>({
              label: v.col1,
              value: v.col2
            }))]
          }
          item.index = index+1
          return item
        })
        this.summaryObject = data.statisticRecord;
        this.pagination = this.getPagination(data);
      }).complete(() => {
        this.loading = false
        this.queryBtnLoading = false
      });
    },
    search(params) {
      this.params = params;
      this.$gjNoticeQuery();
    },
    reset(params) {
      this.pagination.currentPage = 1;
      this.search(params);
    }
  }
}
</script>

<style lang="scss">
.product-analysis-copy {
  height: 100%;
  box-sizing: border-box;
   .table {
    height: calc(100% - 40px);
     .analysis-icon {
      font-size: 21px;
      color: #1F6EEF;
      cursor: pointer;
    }
  }
  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
    overflow-x: hidden;
  }
}
// .product-analysis-copy-table .fixed-left--wrapper.vxe-table--body-wrapper  {
//   overflow-x: hidden !important;
// }
</style>
